import ApiService from './api.service'

const TotpEnrollmentService = {
    setup: async function() {
        const response = await ApiService.customRequest({
            method: 'post',
            url: '/api/Account/setup-authenticator'
        })
        return response.data  // { qrCodeUri, manualKey }
    },

    confirm: async function(manualKey, code) {
        const response = await ApiService.customRequest({
            method: 'post',
            url: '/api/Account/confirm-authenticator',
            data: { ManualKey: manualKey, Code: code }
        })
        return response.data  // { enrolled: true }
    },

    disable: async function() {
        const response = await ApiService.customRequest({
            method: 'post',
            url: '/api/Account/disable-totp'
        })
        return response.data  // { disabled: true }
    }
}

export default TotpEnrollmentService
export { TotpEnrollmentService }
